// src/components/MemberSelector.js
import React ,{useState} from "react";
import {
  FormControl,
  Box,
  Typography,
  IconButton,
  Chip,
  Menu,
  MenuItem,
  Avatar,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import AddIcon from "@mui/icons-material/Add";
import { red } from "@mui/material/colors";

const MemberSelector = ({
  ticketData,
  setTicketData,
  raiseTicket,
  displayAlertMessage,
  message,
  memberList,
}) => {
  const [anchorElMember, setAnchorElMember] = useState(null); // For Member Menu

  const handleMemberClick = (event) => {
    setAnchorElMember(event.currentTarget);
  };

  const handleCloseMemberMenu = () => {
    setAnchorElMember(null);
  };

  const handleToggleMember = (memberId) => {
    setTicketData((prevFormData) => {
      const { memberIds } = prevFormData;

      let updatedFormData;
      if (memberIds.includes(memberId)) {
        // Remove the memberId
        updatedFormData = {
          ...prevFormData,
          memberIds: memberIds.filter((id) => id !== memberId),
        };
        if (raiseTicket(updatedFormData)) {
          displayAlertMessage(message.removeMember)
        }

      } else {
        // Add the memberId
        updatedFormData = {
          ...prevFormData,
          memberIds: [...memberIds, memberId],
        };
        if (raiseTicket(updatedFormData)) {
          displayAlertMessage(message.addMember)
        }
      }

      // Return the updated state
      return updatedFormData;
    });
  };

  const handleDeleteMember = (idToDelete) => {
    if (ticketData.memberIds && ticketData.memberIds.length > 0) {
      const updatedMembers = ticketData.memberIds.filter(
        (mem) => mem !== idToDelete,
      );

      const updatedFormData = {
        ...ticketData,
        memberIds: updatedMembers,
      };
      if (raiseTicket(updatedFormData)) {
        displayAlertMessage(message.removeMember);
      }
      setTicketData(updatedFormData);
    }
  };

  return (
    <FormControl fullWidth>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          minHeight: "44px",
          borderRadius: "8px",
          padding: "6px 8px",
          gap: 1,
        }}
      >
        {/* Label Icon */}
        <PersonIcon color="warning" />

        {/* Selected Members */}
        {ticketData.memberIds && ticketData.memberIds.length > 0 ? (
          ticketData.memberIds.map((mem) => {
            const member = memberList.find((tl) => tl.id === mem);
            const label = ticketData.memberNames?.[mem] || member?.fullName;
            return (
              label && (
                <Chip
                  key={mem}
                  label={label}
                  color="warning"
                  onDelete={() => handleDeleteMember(mem)}
                  sx={{
                    fontSize: "13px",
                    fontWeight: 500,
                  }}
                />
              )
            );
          })
        ) : (
          <Typography
            component="div"
            variant="body2"
            color="warning"
            sx={{ ml: 1 }}
          >
            Members
          </Typography>
        )}

        {/* Add (+) Icon */}
        <IconButton
          size="small"
          sx={{
            backgroundColor: "#fff8e1", // Light yellow tone for warning
            color: "#f57c00", // MUI warning main color
            borderRadius: "50%",
            "&:hover": {
              backgroundColor: "#ffecb3",
            },
          }}
          onClick={handleMemberClick}
        >
          <AddIcon />
        </IconButton>
      </Box>

      {/* Member Selection Menu */}
      <Menu
        anchorEl={anchorElMember}
        open={Boolean(anchorElMember)}
        onClose={handleCloseMemberMenu}
      >
        {memberList.map((member) => (
          <MenuItem
            key={member.id}
            onClick={() => handleToggleMember(member.id)}
            sx={{
              width: "200px",
              fontSize: "14px",
              backgroundColor:
                ticketData.memberIds &&
                ticketData.memberIds.includes(member.id)
                  ? "#eff4ff"
                  : "transparent",
              "&:hover": {
                backgroundColor: "#f5f7fa",
              },
            }}
          >
            <Avatar
              sx={{
                width: 24,
                height: 24,
                fontSize: "12px",
                backgroundColor: red[500],
                color: "white",
                mr: 1,
              }}
            >
              {member.fullName.charAt(0).toUpperCase()}
            </Avatar>
            {member.fullName}
          </MenuItem>
        ))}
      </Menu>
    </FormControl>
  );
};

export default MemberSelector;
